import { motion } from 'framer-motion'
import type { BleStatus } from '@/features/ble/types'

interface StatusDotProps {
  status: BleStatus
  showLabel?: boolean
  className?: string
}

const statusConfig: Record<BleStatus, { color: string; label: string; pulse: boolean }> = {
  idle: { color: 'bg-muted', label: 'Idle', pulse: false },
  scanning: { color: 'bg-status-scanning', label: 'Scanning…', pulse: true },
  connecting: { color: 'bg-status-scanning', label: 'Connecting…', pulse: true },
  connected: { color: 'bg-status-connected', label: 'Connected', pulse: false },
  reconnecting: { color: 'bg-status-scanning', label: 'Reconnecting…', pulse: true },
  disconnected: { color: 'bg-status-disconnected', label: 'Disconnected', pulse: false },
  error: { color: 'bg-status-disconnected', label: 'Error', pulse: true },
}

export function BleStatusIndicator({ status, showLabel = true, className }: StatusDotProps) {
  const cfg = statusConfig[status]

  return (
    <div className={`flex items-center gap-2 ${className ?? ''}`}>
      <span className="relative flex h-2.5 w-2.5">
        {cfg.pulse && (
          <motion.span
            className={`absolute inline-flex h-full w-full rounded-full ${cfg.color} opacity-75`}
            animate={{ scale: [1, 1.8, 1], opacity: [0.75, 0, 0.75] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          />
        )}
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${cfg.color}`} />
      </span>
      {showLabel && (
        <span className="font-mono text-[11px] tracking-wide text-secondary">{cfg.label}</span>
      )}
    </div>
  )
}
